import PropTypes from 'prop-types';
import React from 'react';
import { getOrgTermsContent } from '../../content/utils.js';
import AuthorizedAction, { isAuthorized } from '../AuthorizedAction.js';
import {
  EmployeeChangeImpactsLink,
  EmployeeLink,
  EmployeeStakeholderProfilesLink,
  EmployeeTasksLink,
  PermissionsLink,
  UserLink,
} from '../links/index.jsx';
import Tabs from '../Tabs.jsx';
import { CARRY_SEARCH_ACROSS_TABS } from '../../constants/employeeProfile.js';
import { getEmployeeTabPermissions } from '../../lib/employeeProfilePermissions.js';

const ProfileTabs = ({
  userId,
  employeeId,
  currentUserId,
  orgRole,
  permissions,
  search,
}) => {
  const employeeTabParams =
    CARRY_SEARCH_ACROSS_TABS && search ? { search } : undefined;
  const { canSeeStakeholderProfilesTab } =
    getEmployeeTabPermissions(permissions);

  const PermissionsTab = ({ children }) =>
    userId !== currentUserId ? (
      <AuthorizedAction action="read" subject="userProjectRole">
        {children}
      </AuthorizedAction>
    ) : (
      children
    );

  return (
    <Tabs>
      {userId ? (
        <Tabs.Tab label="Profile">
          <UserLink userId={userId}>Profile</UserLink>
        </Tabs.Tab>
      ) : null}

      {userId &&
      employeeId &&
      (orgRole === 'consultant' ||
        orgRole === 'admin' ||
        isAuthorized('create', 'userProjectRole', permissions)) ? (
        <PermissionsTab>
          <Tabs.Tab label="Permissions">
            <PermissionsLink userId={userId}>Permissions</PermissionsLink>
          </Tabs.Tab>
        </PermissionsTab>
      ) : null}
      {employeeId && orgRole !== 'consultant' ? (
        <Tabs.Tab label={getOrgTermsContent('initiatives')}>
          <EmployeeLink employeeId={employeeId} params={employeeTabParams}>
            Initiatives
          </EmployeeLink>
        </Tabs.Tab>
      ) : null}
      {employeeId && orgRole !== 'consultant' ? (
        <Tabs.Tab label="Change Impacts">
          <EmployeeChangeImpactsLink
            employeeId={employeeId}
            params={employeeTabParams}
          >
            Change Impacts
          </EmployeeChangeImpactsLink>
        </Tabs.Tab>
      ) : null}
      {employeeId && orgRole !== 'consultant' ? (
        <Tabs.Tab label="Tasks">
          <EmployeeTasksLink employeeId={employeeId} params={employeeTabParams}>
            Tasks
          </EmployeeTasksLink>
        </Tabs.Tab>
      ) : null}
      {employeeId &&
      orgRole !== 'consultant' &&
      canSeeStakeholderProfilesTab ? (
        <Tabs.Tab label="Stakeholder Profiles">
          <EmployeeStakeholderProfilesLink
            employeeId={employeeId}
            params={employeeTabParams}
          >
            Stakeholder Profiles
          </EmployeeStakeholderProfilesLink>
        </Tabs.Tab>
      ) : null}
    </Tabs>
  );
};

ProfileTabs.propsTypes = {
  project: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
};

export default ProfileTabs;
